import React from 'react';
import logo from './logo.png';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/useAuth';

interface Props {}

const Navbar = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
  return (
    <nav className="relative container mx-auto p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-20">
          <Link to="/">
            <img src={logo} alt="" className="h-20 w-25" />
          </Link>
          <div className="hidden font-bold lg:flex">
            <Link to="/search" className="text-black hover:text-darkBlue">
              Search
            </Link>
          </div>
        </div>
        {isLoggedIn() ? (
          <div className="hidden lg:flex items-center space-x-6 text-back">
          <div className="hover:text-darkBlue">Welcome, {user?.userName}</div>
            <button
              onClick={logout}
              className="rounded-full bg-emerald-500 px-8 py-3 text-lg font-bold text-white shadow-lg transition duration-300 hover:bg-emerald-600 hover:shadow-emerald-500/50"
            >
              Logout
            </button>
          </div>
        ) : (
          <div className="hidden lg:flex items-center space-x-6 text-back">
            <p>Username: demouser</p>
            <p>Password: Demouser@123</p>
            <Link to="/login" className="hover:text-darkBlue">Login</Link>
            <Link
              to="/register"
              className="rounded-full bg-emerald-500 px-8 py-3 text-lg font-bold text-white shadow-lg transition duration-300 hover:bg-emerald-600 hover:shadow-emerald-500/50"
            >
              Sign up
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;